<template>
  <div class="global-entry">
    <el-menu
      v-if="entryList"
      ref="menu"
      :default-active="defaultActive"
      class="el-menu-demo dgd-menu--dark"
      mode="horizontal"
      menu-trigger="click"
      background-color="#1C2A39"
      text-color="#fff"
      active-text-color="#00A4FF">
      <template v-for="(item, index) in entryList">
        <template v-if="isArray(item)">
          <el-submenu :index="item[0]"
                      popper-class="dgd-menu--dark global-entry-submenu"
                      v-click-outside="closeSubList.bind(instance, item[0])"
                      :hide-timeout="50"
                      :show-timeout="50">
            <template slot="title">{{ entry[item[0]].name }}</template>
            <template v-if="subList[item[0]] && subList[item[0]].list.length">
              <el-menu-item v-for="(child, childIndex) in subList[item[0]].list"
                            :key="childIndex"
                            :index="getSubItemIndex(item[0], child.name)">
                <a :href="child.url">{{ child.name }}</a>
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item">
            <a :href="entry[item].url" :target="entry[item].target">{{ entry[item].name }}</a>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
  import { directive as clickOutside } from 'v-click-outside-x';
  import userCenterBusiness from '@_src/common/core/business/userCenter';
  // import business from './index.js';
  import { mapState } from 'vuex';
  import { typeOf } from '@_src/common/core/utils/helper';
  import config from '@_src/common/core/config';

  export default {
    name: 'global-entry',

    mixins: [userCenterBusiness],

    directives: {
      clickOutside,
    },

    data () {
      const that = this;
      return {
        instance: that,
        subList: {},
      };
    },

    computed: {
      ...mapState({
        user: 'user',
        entry: 'entry',
        entryList: 'entryList',
        currentEntry: 'currentEntry',
        entryListStatus: 'entryListStatus',
        system: 'system',
      }),
      defaultActive () {
        if (this.currentEntry === 'admin/manage/system' || this.currentEntry === 'manage') {
          return encodeURIComponent(`${this.currentEntry}-${this.system.current.name}`);
        }
        return this.currentEntry;
      },
    },

    watch: {
      entryListStatus: {
        handler (val) {
          // 当系统管理所依赖的数据初始化完成后
          if (val) {
            this.entryList.forEach(item => {
              if (this.isArray(item)) {
                this.$set(this.subList, item[0], {
                  // arrow: 0,
                  // status: 0,
                  list: [].concat(item.slice(1)),
                });
              }
            });
          }
        },
      },
    },

    methods: {
      isArray (item) {
        return typeOf(item) === 'array';
      },

      closeSubList (item) {
        this.$refs.menu.close(item);
      },

      getSubItemIndex (parent, name) {
        return encodeURIComponent(`${parent}-${name}`);
      },

      // jumpUrl (item) {
      //   if (this.isArray(item)) {
      //     if (this.subList[item[0]] && this.subList[item[0]].list.length === 0) {
      //       window.location.href = this.entry[item[0]].url;
      //     }
      //     return false;
      //   }
      //   if (this.entry[item].target === '_blank') {
      //     window.open(this.entry[item].url);
      //   }
      //   else {
      //     window.location.href = this.entry[item].url;
      //   }
      //   return false;
      // },
    },

    mounted () {
      window.localStorage.setItem(config.lsEntry,
        JSON.stringify(this.$store.state.entry));
      window.localStorage.setItem(config.lsEntryList,
        JSON.stringify(this.$store.state.entryList));
    },
  };
</script>

<style lang="less" src="./index.less"></style>
